import { render, staticRenderFns } from "./MultilingualTextField.vue?vue&type=template&id=2ab92d96"
import script from "./MultilingualTextField.vue?vue&type=script&lang=js"
export * from "./MultilingualTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports